var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FA0000",
    d: "M0 .995C0 .445.447 0 .997 0h6.006C7.553 0 8 .45 8 .995v8.01c0 .55-.447.995-.997.995H.997C.447 10 0 9.55 0 9.005V.995zM10 8.995c0-.55.447-.995.997-.995h6.006c.55 0 .997.45.997.995v8.01c0 .55-.447.995-.997.995h-6.006c-.55 0-.997-.45-.997-.995v-8.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2 2L2 8 6 8 6 2zM12 10L12 16 16 16 16 10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00368E",
    d: "M0 13.004C0 12.45.447 12 .997 12h6.006c.55 0 .997.451.997 1.004v3.992C8 17.55 7.553 18 7.003 18H.997C.447 18 0 17.549 0 16.996v-3.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2 14L2 16 6 16 6 14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00368E",
    d: "M10 1.004C10 .45 10.447 0 10.997 0h6.006c.55 0 .997.451.997 1.004v3.992C18 5.55 17.553 6 17.003 6h-6.006C10.447 6 10 5.549 10 4.996V1.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M12 2L12 4 16 4 16 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard_active.7e5b09a23b445c2347ed3f30b3c10d34.svg";
export { ForwardRef as ReactComponent };